export default "__VITE_ASSET__CX7mGhr4__"